(function () {
  var DISMISSED_KEY = 'h4h_cart_reminder_dismissed';
  var positionRetryTimer = null;

  function getReminder() {
    return document.getElementById('cart-reminder');
  }

  function isDesktop() {
    return window.matchMedia('(min-width: 641px)').matches;
  }

  function isDismissed() {
    return sessionStorage.getItem(DISMISSED_KEY) === 'true';
  }

  function permanentlyDismissReminder() {
    sessionStorage.setItem(DISMISSED_KEY, 'true');
    hideReminder();
  }

  function hideReminder() {
    var reminder = getReminder();
    if (!reminder) return;

    reminder.setAttribute('aria-hidden', 'true');
    reminder.style.left = '';
    reminder.style.right = '';
    reminder.style.top = '';

    if (positionRetryTimer) {
      clearTimeout(positionRetryTimer);
      positionRetryTimer = null;
    }
  }

  function getHeaderContainer() {
    return document.querySelector('.header > .container');
  }

  function positionDesktopReminder(reminder, cartIcon, caret) {
    var container = getHeaderContainer();
    var cartItem = reminder.closest('.header__action-item--cart');

    if (!container || !cartItem) return;

    reminder.style.left = 'auto';
    reminder.style.right = '0';

    var containerRect = container.getBoundingClientRect();
    var cartItemRect = cartItem.getBoundingClientRect();
    var reminderRect = reminder.getBoundingClientRect();

    if (reminderRect.left < containerRect.left) {
      reminder.style.right = 'auto';
      reminder.style.left = Math.round(containerRect.left - cartItemRect.left) + 'px';
      reminderRect = reminder.getBoundingClientRect();
    }

    var cartRect = cartIcon.getBoundingClientRect();
    var cartCenter = cartRect.left + cartRect.width / 2;
    var caretOffset = cartCenter - reminderRect.left;

    caret.style.left = Math.round(caretOffset) + 'px';
    caret.style.marginLeft = '-9px';
  }

  function positionReminder() {
    var reminder = getReminder();
    var cartToggle = document.querySelector('.header__cart-toggle');
    var cartIcon = cartToggle && (cartToggle.querySelector('.header__cart-icon') || cartToggle);
    var caret = reminder && reminder.querySelector('.cart-reminder__caret');

    if (!reminder || !cartIcon || !caret) return;

    if (isDesktop()) {
      reminder.style.top = '';
      positionDesktopReminder(reminder, cartIcon, caret);
    }
  }

  function schedulePositioning() {
    var attempts = 0;

    if (positionRetryTimer) {
      clearTimeout(positionRetryTimer);
      positionRetryTimer = null;
    }

    function run() {
      var reminder = getReminder();
      if (!reminder || reminder.getAttribute('aria-hidden') === 'true') return;

      positionReminder();
      attempts += 1;

      // Reposition a few times to catch late layout shifts (fonts, AB CSS, header changes)
      if (attempts < 10) {
        positionRetryTimer = setTimeout(run, 120);
      } else {
        positionRetryTimer = null;
      }
    }

    requestAnimationFrame(run);
  }

  function showReminder() {
    var reminder = getReminder();
    if (!reminder) return;

    var miniCart = document.getElementById('mini-cart');
    if (miniCart && miniCart.getAttribute('aria-hidden') === 'false') {
      return;
    }

    reminder.setAttribute('aria-hidden', 'false');
    schedulePositioning();
  }

  function openMiniCart() {
    var miniCart = document.getElementById('mini-cart');
    var cartToggle = document.querySelector('.header__cart-toggle[data-action="toggle-mini-cart"]');

    if (!miniCart || !cartToggle || miniCart.getAttribute('aria-hidden') !== 'true') {
      return;
    }

    cartToggle.click();
  }

  function handleOpenCart() {
    hideReminder();
    openMiniCart();
  }

  function shouldShowReminder(reminder) {
    var cartCount = parseInt(reminder.dataset.cartCount, 10) || 0;
    return cartCount > 0 && !isDismissed();
  }

  function initReminder() {
    var reminder = getReminder();
    if (!reminder) return;

    if (!shouldShowReminder(reminder)) return;

    window.setTimeout(showReminder, 400);
  }

  function bindEvents() {
    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-action="close-cart-reminder"]')) {
        event.preventDefault();
        permanentlyDismissReminder();
        return;
      }

      if (event.target.closest('[data-action="open-cart-from-reminder"]')) {
        event.preventDefault();
        handleOpenCart();
        return;
      }

      var reminder = getReminder();
      if (!reminder || reminder.getAttribute('aria-hidden') === 'true') return;

      if (isDesktop()) {
        var popover = reminder.querySelector('.cart-reminder__popover');
        if (
          popover &&
          !popover.contains(event.target) &&
          !event.target.closest('.header__cart-toggle')
        ) {
          hideReminder();
        }
      }
    });

    document.addEventListener('keyup', function (event) {
      if (event.key !== 'Escape') return;

      var reminder = getReminder();
      if (reminder && reminder.getAttribute('aria-hidden') === 'false') {
        hideReminder();
      }
    });

    window.addEventListener('resize', function () {
      var reminder = getReminder();
      if (reminder && reminder.getAttribute('aria-hidden') === 'false') {
        positionReminder();
      }
    });

    window.addEventListener('load', function () {
      var reminder = getReminder();
      if (reminder && reminder.getAttribute('aria-hidden') === 'false') {
        schedulePositioning();
      }
    });

    var miniCart = document.getElementById('mini-cart');
    if (miniCart) {
      var observer = new MutationObserver(function () {
        if (miniCart.getAttribute('aria-hidden') === 'false') {
          hideReminder();
        }
      });

      observer.observe(miniCart, {
        attributes: true,
        attributeFilter: ['aria-hidden']
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      bindEvents();
      initReminder();
    });
  } else {
    bindEvents();
    initReminder();
  }
})();
